export default "__VITE_ASSET__$VsHLqDZ__"